import { useMutation } from "@apollo/client";
import { UPDATE_INTEGRATION_SYNC_SETTINGS_MUTATION } from "../../../apis/salesforce/queries";
import { HG_FORCE_CLIENT } from "../../../utils/consts";
import {
  UpdateIntegrationSyncSettingsResponse,
  UpdateIntegrationSyncSettingsVariables,
} from "../types";

export interface UseUpdateIntegrationSyncSettingsOptions {
  onCompleted?: (data: UpdateIntegrationSyncSettingsResponse) => void;
  onError?: (error: Error) => void;
}

export const useUpdateIntegrationSyncSettings = (
  options: UseUpdateIntegrationSyncSettingsOptions = {}
) => {
  const { onCompleted, onError } = options;

  const [updateSyncSettingsMutation, result] = useMutation<
    UpdateIntegrationSyncSettingsResponse,
    UpdateIntegrationSyncSettingsVariables
  >(UPDATE_INTEGRATION_SYNC_SETTINGS_MUTATION, {
    context: { clientName: HG_FORCE_CLIENT },
    onCompleted,
    onError,
    errorPolicy: "all",
  });

  const updateSyncSettings = async (
    variables: UpdateIntegrationSyncSettingsVariables
  ) => {
    try {
      const response = await updateSyncSettingsMutation({ variables });
      return response.data?.updateIntegrationSyncSettings;
    } catch (error) {
      console.error("Error updating sync settings:", error);
      throw error;
    }
  };

  return {
    updateSyncSettings,
    ...result,
    integration: result.data?.updateIntegrationSyncSettings,
  };
};
